import { useLocation, useNavigate, useParams } from 'react-router-dom'

interface GoToVehicleParams {
  sortedIds: string[]
  numericId: string
}

const useChangeVehicleParams = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { vehicleId } = useParams<{ vehicleId?: string }>()

  // Use the router-parsed current `vehicleId` as the needle (instead of a
  // broader regex) so we swap exactly the segment the router sees.
  const goToVehicle = (newId: number) => {
    if (!vehicleId) return
    const from = `/vehicle/${vehicleId}`
    const to = `/vehicle/${newId}`
    if (!location.pathname.includes(from)) return
    navigate(location.pathname.replace(from, to))
  }

  const goPrevVehicleInActivity = ({ sortedIds, numericId }: GoToVehicleParams) => {
    const numericIdNum = Number(numericId)
    const sortedIdsNum = sortedIds.map(Number).sort((a, b) => a - b)
    const prevId =
      [...sortedIdsNum].reverse().find((id) => id < numericIdNum) ??
      sortedIdsNum[sortedIdsNum.length - 1]
    goToVehicle(prevId)
  }

  const goNextVehicleInActivity = ({ sortedIds, numericId }: GoToVehicleParams) => {
    const numericIdNum = Number(numericId)
    const sortedIdsNum = sortedIds.map(Number).sort((a, b) => a - b)
    const nextId =
      sortedIdsNum.find((id) => id > numericIdNum) ?? sortedIdsNum[0]
    goToVehicle(nextId)
  }

  const replaceUrlParam = ({
    paramNames,
    newValue,
  }: {
    paramNames: string[]
    newValue: string | number
  }) => {
    for (const paramName of paramNames) {
      const regex = new RegExp(`${paramName}/[^/]+`)
      if (regex.test(location.pathname)) {
        navigate(location.pathname.replace(regex, `${paramName}/${newValue}`))
        return
      }
    }
  }

  return {
    goPrevVehicleInActivity,
    goNextVehicleInActivity,
    replaceUrlParam,
  }
}

export default useChangeVehicleParams
